import React, { useEffect, useState } from 'react';
import { Form, Select, Button, Row, Col, Modal, Input, DatePicker, Spin, notification } from 'antd';
import { ChevronRight, CloseIcon, ChevronDown, ChevronLeft, ChevronUp, RealBricksLogo } from '../../../assets/icons';
import FloatingLabel from '../../../components/FloatingLabel/FloatingLabel';
import { Images } from '../../../config/images';
import { getFundingSources } from '../../../services/AccountApi/paymentMethodApi';
import { toastNotify } from '../../../utils/toastNotify';
import { initiateTranserApi } from '../../../services/AccountApi/transactionsApi';
import { NewTransfer } from '../../../utils/constant';
import moment from 'moment';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getBankLogo } from '../../../utils/getBankLogo';
import { getUsCurrencyFormat } from '../../../utils/usCurrencyFormatter';
import { ERROR_BALANCE_BANK_MESSAGE } from '../../../utils/constant';

const InitiateTransferModal = (props) => {
  const { isTransferModalOpen, closeTransferModal, openTransferCompleteModal, modalType, initiateTransferedData, openTransection, isDepositModal } = props;
  const isWithdrawModal = modalType === NewTransfer.Portfolio;
  const [accountOptions, setAccountOptions] = useState([]);
  const [, setWalltetData] = useState({});
  const [transferFrom, setTransferFrom] = useState('default');
  const [transferTo, setTransferTo] = useState('default');
  const [amount, setAmount] = useState();
  const [transferDate, setTransferDate] = useState(moment());
  const [form] = Form.useForm();
  const [optionLoading, setOptionLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isSameTypeError, setSameTypeError] = useState(null);
  const [typeOpen, setTypeOpen] = useState('');
  const [calendarOpen, setCalendarOpen] = useState(false);
  // const {
  //   isTransferModalOpen,
  //   closeTransferModal,
  //   openTransferCompleteModal,
  //   initiateTransferedData
  // } = props;

  useEffect(() => {
    getFundingSourcesFun();
    setTransferDate(moment());
    form.setFieldsValue({ transferDate: moment() });
  }, []);

  useEffect(() => {
    if (openTransection) {
      let DwollaWallet = accountOptions?.filter((item) => item?.brandName === 'DWOLLA' && item);
      setTransferFrom({
        key: `${DwollaWallet[0]?.id}`,
        children: 'Dwolla Wallet',
        selected: true,
        value: DwollaWallet[0]?.id,
        title: 'Wallet',
      });
      form.setFieldsValue({ transferFrom: DwollaWallet[0]?.id });
    }
  }, [openTransection, accountOptions]);

  const getFundingSourcesFun = async () => {
    setOptionLoading(true);
    try {
      const resp = await getFundingSources();
      if (!resp.isError) {
        const { wallets, banks } = resp.data;
        setAccountOptions([...banks, ...wallets]);
        setWalltetData({ ...wallets[0] });
        if (isWithdrawModal) {
          const id = wallets[0].id;
          setTransferFrom({
            key: `${id}`,
            children: 'Dwolla Wallet',
            selected: true,
            value: id,
            title: 'Wallet',
          });
          form.setFieldsValue({ transferFrom: id });
        }
        if (isDepositModal && wallets.length) {
          const id = wallets[0].id;
          setTransferTo({
            key: `${id}`,
            children: 'Dwolla Wallet',
            selected: true,
            value: id,
            title: 'Wallet',
          });
          form.setFieldsValue({ transferTo: id });
        }
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setOptionLoading(false);
    }
  };

  const initiateAccOptions = (options, optionLoading, isTransferFrom) => {
    let optionsArray = []
    if (options.length > 0 && isDepositModal && isTransferFrom) {
      options.forEach(optionData => {
        if (optionData.sourceType === 'Bank') {
          optionsArray.push(
            <Select.Option value={optionData.id} key={optionData.id} title={optionData.sourceType}>
              {getBankLogo(optionData?.brandName, '')}
              <span className='ml-8'>
                {optionData.brandName}***{optionData.lastFourDigit}
              </span>
            </Select.Option>
          )
        }
      });

    } else {
      const generateOptions = options.map((optionData) => {
        // const isDefaultSelect = optionData.isPrimarySource ? 'selected' : '';
        return optionData.sourceType === 'Bank' ? (
          <Select.Option disabled={optionData?.bankVerificationStatus !== "Verified"} value={optionData.id} key={optionData.id} title={optionData.sourceType}>
            {getBankLogo(optionData?.brandName, '')}
            <span className='ml-8'>
              {optionData.brandName}***{optionData.lastFourDigit}
            </span>
          </Select.Option> //Bank Account Options
        ) : (
          <Select.Option value={optionData.id} key={optionData.id} title={optionData.sourceType} selected>
            <RealBricksLogo size={24} marginRight='8px' verticalAlign='middle' />
            Realbricks Wallet ${getUsCurrencyFormat(optionData.availableBalance)}
          </Select.Option>
        ); //Dwolla Wallet Option
      })
      optionsArray = [...generateOptions]
    }
    return (
      <>
        {optionLoading && (
          <Select.Option disabled>
            <Spin className='ant-spin--centered' />
          </Select.Option>
        )}
        {optionsArray}

      </>
    );
  };

  const onChangeTransferFrom = (value, option) => {
    if (isWithdrawModal) {
      return;
    } else {
      setTransferFrom(option);
    }
    if (option.title === transferTo.title) {
      setSameTypeError('Please select different Type of account');
    } else {
      setSameTypeError(null);
    }
  };
  const onChangeTransferTo = (value, option) => {
    if (isDepositModal) {
      return;
    }
    if (option.title === transferFrom.title) {
      setSameTypeError('Please select different Type of account');
    } else {
      setSameTypeError(null);
      setTransferTo(option);
    }
  };

  const onDateChange = (date) => {
    setTransferDate(date);
  };

  // Can not select days before today and today
  const disabledDate = (current) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    return current && current < yesterday;
  };

  const onInitiateTransfer = async (values) => {
    setLoader(true);
    const initiateFormData = {
      sourceAccountId: parseInt(isWithdrawModal ? transferFrom.key : values.transferFrom),
      destinationAccountId: parseInt(isDepositModal ? transferTo.key : values.transferTo),
      amount: Number(values.amount),
      date: values.transferDate,
    };
    try {
      const resp = await initiateTranserApi(initiateFormData);
      if (!resp.isError) {
        closeTransferModal(false);
        initiateTransferedData(resp.data);
        openTransferCompleteModal(true);
      } else {
        if (resp?.message === 'INSUFFICIENT_FUND_ERROR') {
          const width = window.innerWidth;
            notification.error({
              message: '',
              description: ERROR_BALANCE_BANK_MESSAGE,
              duration: 3,
              placement: width > 1024 ? 'bottomRight' : 'topRight',
            });
            closeTransferModal(false)
            // User is frozen, logout and redirect to login page
            setTimeout(() => {
              localStorage.clear();
              localStorage.setItem('prev_pathname', window.location.pathname);
              window.location.href = '/login';
            }, 3000); // Wait 3 seconds to show the error message before redirecting
        } else {
          toastNotify('error', resp?.message);
        }
      }
    } catch (error) {
      const { response } = error;
      if (response?.data?.message === 'INSUFFICIENT_FUND_ERROR') {
        const width = window.innerWidth;
            notification.error({
              message: '',
              description: ERROR_BALANCE_BANK_MESSAGE,
              duration: 3,
              placement: width > 1024 ? 'bottomRight' : 'topRight',
            });
            closeTransferModal(false)
            // User is frozen, logout and redirect to login page
            setTimeout(() => {
              localStorage.clear();
              localStorage.setItem('prev_pathname', window.location.pathname);
              window.location.href = '/login';
            }, 3000); // Wait 3 seconds to show the error message before redirecting
      } else {
        toastNotify('error', response?.data?.message);
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal
      open={isTransferModalOpen}
      width={524}
      footer={false}
      closeIcon={<CloseIcon />}
      onCancel={() => closeTransferModal(false)}
      maskClosable={false}
      centered
    >
      <div className='text-center mb-16'>
        <LazyLoadImage src={Images.transfer} alt='Outline of a bank with arrow' />
      </div>
      <h4 className='text-center'>New transfer</h4>
      <p className='mb-32'>
        Transfers to and from your Realbricks account will take 2 - 5 business days to complete. Exact timing depends on your bank.
      </p>
      <Form className='transfer-form' name='initiateTransferForm' form={form} onFinish={onInitiateTransfer} autoComplete='off'>
        <FloatingLabel label='Transfer from' inputId='transferFrom' inputValue={transferFrom}>
          <div id='dropdown-from' />
          <Form.Item
            name='transferFrom'
            rules={[
              {
                required: true,
                message: 'Select account',
              },
            ]}
          >
            <Select
              id='transferFrom'
              open={typeOpen === 'from'}
              onChange={(value, option) => {
                onChangeTransferFrom(value, option);
                setTypeOpen('');
              }}
              onClick={() => setTypeOpen(typeOpen === 'from' ? '' : 'from')}
              value={transferFrom}
              placeholder='Choose account'
              disabled={isWithdrawModal}
              getPopupContainer={() => document.getElementById('dropdown-from')}
              suffixIcon={typeOpen === 'from' ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
            >
              {initiateAccOptions(accountOptions, optionLoading, true)}
            </Select>
          </Form.Item>
        </FloatingLabel>
        <FloatingLabel label='Transfer to' inputId='transferTo' inputValue={transferTo}>
          <div id='dropdown-to' />
          <Form.Item
            name='transferTo'
            validateStatus={isSameTypeError && 'error'}
            help={isSameTypeError}
            rules={[
              {
                required: true,
                message: 'Select account',
              },
            ]}
          >
            <Select
              id='transferTo'
              placeholder='Choose account'
              open={typeOpen === 'to'}
              // onChange={(value) => setTransferTo(value)}
              onChange={(value, option) => {
                onChangeTransferTo(value, option);
                setTypeOpen('');
              }}
              disabled={isDepositModal}
              onClick={() => setTypeOpen(typeOpen === 'to' ? '' : 'to')}
              getPopupContainer={() => document.getElementById('dropdown-to')}
              // value={transferTo}
              suffixIcon={typeOpen === 'to' ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
            >
              {initiateAccOptions(accountOptions, optionLoading)}
            </Select>
          </Form.Item>
        </FloatingLabel>
        <FloatingLabel label='Enter amount' shortLabel='Amount' inputId='amount' inputValue={amount}>
          <Form.Item
            name='amount'
            rules={[
              {
                required: true,
                message: 'Please enter amount',
              },
              {
                pattern: /^(?!0+(\.0+)?$)\d+(\.\d{1,2})?$/,
                message: 'Please enter a valid amount. The value should have no more than two decimal points and must be greater than zero." ',
              },
            ]}
          >
            <Input
              type='text'
              id='amount'
              prefix={amount ? <>$</> : <></>}
              placeholder='Enter amount'
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </Form.Item>
        </FloatingLabel>
        <FloatingLabel label='Choose date' shortLabel='Date of transfer' inputId='transferDate' inputValue={transferDate}>
          <>
            <div id='calendar-anchor' />
            <Form.Item
              name='transferDate'
              rules={[
                {
                  required: true,
                  message: 'Please select date',
                },
              ]}
              validateTrigger='onBlur'
            >
              <DatePicker
                id='transferDate'
                placeholder='Choose date'
                allowClear={false}
                suffixIcon={calendarOpen ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                onOpenChange={() => setCalendarOpen(!calendarOpen)}
                nextIcon={<ChevronRight size={24} verticalAlign='1px' color='#1A1519' />}
                prevIcon={<ChevronLeft size={24} verticalAlign='1px' color='#1A1519' />}
                superNextIcon={false}
                superPrevIcon={false}
                showToday={false}
                format='MMMM DD, YYYY'
                defaultValue={transferDate}
                value={transferDate}
                onChange={onDateChange}
                disabledDate={disabledDate}
                getPopupContainer={() => document.getElementById('calendar-anchor')}
                inputReadOnly
              />
            </Form.Item>
          </>
        </FloatingLabel>
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12}>
            <Form.Item className='mb-0'>
              <Button className='w-100' onClick={() => closeTransferModal(false)}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col span={24} sm={12}>
            <Form.Item className='mb-0' shouldUpdate>
              {() => (
                <Button
                  className='w-100'
                  type='primary'
                  htmlType='submit'
                  loading={loader}
                  disabled={
                    !form.isFieldsTouched(true) || isSameTypeError || !!form.getFieldsError().filter(({ errors }) => errors.length).length || loader
                  }
                >
                  Initiate Transfer
                </Button>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default InitiateTransferModal;
